"use strict";
var _a;
exports.__esModule = true;
exports.createCommand = exports.RoutePlanner = exports.CommandType = void 0;
var ethers = require("ethers").ethers;
/**
 * CommandTypes
 * @description Flags that modify a command's execution
 * @enum {number}
 */
var CommandType;
(function (CommandType) {
    CommandType[CommandType["V3_SWAP_EXACT_IN"] = 0] = "V3_SWAP_EXACT_IN";
    CommandType[CommandType["V3_SWAP_EXACT_OUT"] = 1] = "V3_SWAP_EXACT_OUT";
    CommandType[CommandType["PERMIT2_TRANSFER_FROM"] = 2] = "PERMIT2_TRANSFER_FROM";
    CommandType[CommandType["PERMIT2_PERMIT_BATCH"] = 3] = "PERMIT2_PERMIT_BATCH";
    CommandType[CommandType["SWEEP"] = 4] = "SWEEP";
    CommandType[CommandType["TRANSFER"] = 5] = "TRANSFER";
    CommandType[CommandType["PAY_PORTION"] = 6] = "PAY_PORTION";
    CommandType[CommandType["V2_SWAP_EXACT_IN"] = 8] = "V2_SWAP_EXACT_IN";
    CommandType[CommandType["V2_SWAP_EXACT_OUT"] = 9] = "V2_SWAP_EXACT_OUT";
    CommandType[CommandType["PERMIT2_PERMIT"] = 10] = "PERMIT2_PERMIT";
    CommandType[CommandType["WRAP_ETH"] = 11] = "WRAP_ETH";
    CommandType[CommandType["UNWRAP_WETH"] = 12] = "UNWRAP_WETH";
    CommandType[CommandType["PERMIT2_TRANSFER_FROM_BATCH"] = 13] = "PERMIT2_TRANSFER_FROM_BATCH";
    CommandType[CommandType["BALANCE_CHECK_ERC20"] = 14] = "BALANCE_CHECK_ERC20";
    // NFT-related command types
    CommandType[CommandType["SEAPORT_V1_5"] = 16] = "SEAPORT_V1_5";
    CommandType[CommandType["LOOKS_RARE_V2"] = 17] = "LOOKS_RARE_V2";
    CommandType[CommandType["NFTX"] = 18] = "NFTX";
    CommandType[CommandType["CRYPTOPUNKS"] = 19] = "CRYPTOPUNKS";
    // 0x14,
    CommandType[CommandType["OWNER_CHECK_721"] = 21] = "OWNER_CHECK_721";
    CommandType[CommandType["OWNER_CHECK_1155"] = 22] = "OWNER_CHECK_1155";
    CommandType[CommandType["SWEEP_ERC721"] = 23] = "SWEEP_ERC721";
    CommandType[CommandType["X2Y2_721"] = 24] = "X2Y2_721";
    CommandType[CommandType["SUDOSWAP"] = 25] = "SUDOSWAP";
    CommandType[CommandType["NFT20"] = 26] = "NFT20";
    CommandType[CommandType["X2Y2_1155"] = 27] = "X2Y2_1155";
    CommandType[CommandType["FOUNDATION"] = 28] = "FOUNDATION";
    CommandType[CommandType["SWEEP_ERC1155"] = 29] = "SWEEP_ERC1155";
    CommandType[CommandType["ELEMENT_MARKET"] = 30] = "ELEMENT_MARKET";
    CommandType[CommandType["SEAPORT_V1_4"] = 32] = "SEAPORT_V1_4";
    CommandType[CommandType["EXECUTE_SUB_PLAN"] = 33] = "EXECUTE_SUB_PLAN";
    CommandType[CommandType["APPROVE_ERC20"] = 34] = "APPROVE_ERC20";
})(CommandType = exports.CommandType || (exports.CommandType = {}));
var ALLOW_REVERT_FLAG = 0x80;
var REVERTIBLE_COMMANDS = new Set([
    CommandType.SEAPORT_V1_5,
    CommandType.SEAPORT_V1_4,
    CommandType.NFTX,
    CommandType.LOOKS_RARE_V2,
    CommandType.X2Y2_721,
    CommandType.X2Y2_1155,
    CommandType.FOUNDATION,
    CommandType.SUDOSWAP,
    CommandType.NFT20,
    CommandType.EXECUTE_SUB_PLAN,
    CommandType.CRYPTOPUNKS,
    CommandType.ELEMENT_MARKET,
]);
var PERMIT_STRUCT = '((address token,uint160 amount,uint48 expiration,uint48 nonce) details, address spender, uint256 sigDeadline)';
var PERMIT_BATCH_STRUCT = '((address token,uint160 amount,uint48 expiration,uint48 nonce)[] details, address spender, uint256 sigDeadline)';
var PERMIT2_TRANSFER_FROM_STRUCT = '(address from,address to,uint160 amount,address token)';
var PERMIT2_TRANSFER_FROM_BATCH_STRUCT = PERMIT2_TRANSFER_FROM_STRUCT + '[]';
var ABI_DEFINITION = (_a = {},
    // Batch Reverts
    _a[CommandType.EXECUTE_SUB_PLAN] = ['bytes', 'bytes[]'],
    // Permit2 Actions
    _a[CommandType.PERMIT2_PERMIT] = [PERMIT_STRUCT, 'bytes'],
    _a[CommandType.PERMIT2_PERMIT_BATCH] = [PERMIT_BATCH_STRUCT, 'bytes'],
    _a[CommandType.PERMIT2_TRANSFER_FROM] = ['address', 'address', 'uint160'],
    _a[CommandType.PERMIT2_TRANSFER_FROM_BATCH] = [PERMIT2_TRANSFER_FROM_BATCH_STRUCT],
    // Uniswap Actions
    _a[CommandType.V3_SWAP_EXACT_IN] = ['address', 'uint256', 'uint256', 'bytes', 'bool'],
    _a[CommandType.V3_SWAP_EXACT_OUT] = ['address', 'uint256', 'uint256', 'bytes', 'bool'],
    _a[CommandType.V2_SWAP_EXACT_IN] = ['address', 'uint256', 'uint256', 'address[]', 'bool'],
    _a[CommandType.V2_SWAP_EXACT_OUT] = ['address', 'uint256', 'uint256', 'address[]', 'bool'],
    // Token Actions and Checks
    _a[CommandType.WRAP_ETH] = ['address', 'uint256'],
    _a[CommandType.UNWRAP_WETH] = ['address', 'uint256'],
    _a[CommandType.SWEEP] = ['address', 'address', 'uint256'],
    _a[CommandType.SWEEP_ERC721] = ['address', 'address', 'uint256'],
    _a[CommandType.SWEEP_ERC1155] = ['address', 'address', 'uint256', 'uint256'],
    _a[CommandType.TRANSFER] = ['address', 'address', 'uint256'],
    _a[CommandType.PAY_PORTION] = ['address', 'address', 'uint256'],
    _a[CommandType.BALANCE_CHECK_ERC20] = ['address', 'address', 'uint256'],
    _a[CommandType.OWNER_CHECK_721] = ['address', 'address', 'uint256'],
    _a[CommandType.OWNER_CHECK_1155] = ['address', 'address', 'uint256', 'uint256'],
    _a[CommandType.APPROVE_ERC20] = ['address', 'uint256'],
    // NFT Markets
    _a[CommandType.SEAPORT_V1_5] = ['uint256', 'bytes'],
    _a[CommandType.SEAPORT_V1_4] = ['uint256', 'bytes'],
    _a[CommandType.NFTX] = ['uint256', 'bytes'],
    _a[CommandType.LOOKS_RARE_V2] = ['uint256', 'bytes'],
    _a[CommandType.X2Y2_721] = ['uint256', 'bytes', 'address', 'address', 'uint256'],
    _a[CommandType.X2Y2_1155] = ['uint256', 'bytes', 'address', 'address', 'uint256', 'uint256'],
    _a[CommandType.FOUNDATION] = ['uint256', 'bytes', 'address', 'address', 'uint256'],
    _a[CommandType.SUDOSWAP] = ['uint256', 'bytes'],
    _a[CommandType.NFT20] = ['uint256', 'bytes'],
    _a[CommandType.CRYPTOPUNKS] = ['uint256', 'address', 'uint256'],
    _a[CommandType.ELEMENT_MARKET] = ['uint256', 'bytes'],
    _a);
var RoutePlanner = /** @class */ (function () {
    function RoutePlanner() {
        this.commands = '0x';
        this.inputs = [];
    }
    RoutePlanner.prototype.addSubPlan = function (subplan) {
        this.addCommand(CommandType.EXECUTE_SUB_PLAN, [subplan.commands, subplan.inputs], true);
    };
    RoutePlanner.prototype.addCommand = function (type, parameters, allowRevert) {
        if (allowRevert === void 0) { allowRevert = false; }
        var command = createCommand(type, parameters);
        this.inputs.push(command.encodedInput);
        if (allowRevert) {
            if (!REVERTIBLE_COMMANDS.has(command.type)) {
                throw new Error("command type: ".concat(command.type, " cannot be allowed to revert"));
            }
            command.type = command.type | ALLOW_REVERT_FLAG;
        }
        this.commands = this.commands.concat(command.type.toString(16).padStart(2, '0'));
    };
    return RoutePlanner;
}());
exports.RoutePlanner = RoutePlanner;
function createCommand(type, parameters) {
    var encodedInput = ethers.AbiCoder.defaultAbiCoder().encode(ABI_DEFINITION[type], parameters);
    return { type: type, encodedInput: encodedInput };
}
exports.createCommand = createCommand;
